import * as React from "react";
import type { SVGProps } from "react";
const Spa = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.6292 11.1378a12.2 12.2 0 0 1 3.575 3.3542c.2916.4125.5583.8458.7958 1.2917.2375-.45.5042-.8792.7958-1.2917a12.2 12.2 0 0 1 3.575-3.3542A12.14 12.14 0 0 1 22.75 9.3337h.4125c.4625 0 .8375.375.8375.8375 0 6.1666-4.9958 11.1625-11.1625 11.1625h-1.675C4.9958 21.3337 0 16.3378 0 10.1712c0-.4625.375-.8375.8375-.8375H1.25c2.3292 0 4.5167.6583 6.3792 1.8041m4.9333-8.2375c.6542.7042 2.5458 2.9917 3.5167 6.8584A13.55 13.55 0 0 0 12 13.3253c-1.1042-1.45-2.4958-2.6625-4.0792-3.5666.9667-3.8667 2.8584-6.1542 3.5167-6.8584.1458-.1541.35-.2333.5625-.2333s.4167.0792.5625.2333"
    />
  </svg>
);
export default Spa;
